// export const baseUrl = "http://localhost:8000";
export const baseUrl = "https://icpalemanage.com";
// export const baseUrl = "https://phase2.icpalemanage.com";
// export const baseUrl = "https://phase5.icpalemanage.com";